export default __webpack_public_path__ + "static/media/success.e7fd18c1.svg";